var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.625C36.8848 17.625 42.5 23.2402 42.5 30.125C42.5 37.0586 36.8848 42.625 30 42.625C23.0664 42.625 17.5 37.0586 17.5 30.125C17.5 23.2402 23.0664 17.625 30 17.625ZM30 23.875C29.1211 23.875 28.4375 24.6074 28.4375 25.4375C28.4375 26.3164 29.1211 27 30 27C30.8301 27 31.5625 26.3164 31.5625 25.4375C31.5625 24.6074 30.8301 23.875 30 23.875ZM31.9531 36.375C32.5879 36.375 33.125 35.8867 33.125 35.2031C33.125 34.5684 32.5879 34.0312 31.9531 34.0312H31.1719V29.7344C31.1719 29.0996 30.6348 28.5625 30 28.5625H28.4375C27.7539 28.5625 27.2656 29.0996 27.2656 29.7344C27.2656 30.418 27.7539 30.9062 28.4375 30.9062H28.8281V34.0312H28.0469C27.3633 34.0312 26.875 34.5684 26.875 35.2031C26.875 35.8867 27.3633 36.375 28.0469 36.375H31.9531Z",
    fill: "url(#paint0_linear_1101_45553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_45553",
    x1: 25.6614,
    y1: 40.5,
    x2: 39.5935,
    y2: 23.9142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/infoButton.071d27bce47aa462384d9c4d99eee2d0.svg";
export { ForwardRef as ReactComponent };